import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-inline-confirmation-message',
  standalone: true,
  host: {
    "class": "mat-body-small"
  },
  imports: [],
  templateUrl: './inline-confirmation-message.component.html',
  styleUrl: './inline-confirmation-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class InlineConfirmationMessageComponent {}
